import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_FBP_BANDS);

const state = {
    data: [],
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    fbpId: '',
    record: {}
};

const getters = {
    getFbpBands: (state) => {
        if (state.data) {
            return state.data
        } else {
            this.fetchAll()
        }
    },
    editMode: (state) => {
        return state.editMode
    },
    record: (state) => {
        return state.record
    },
    getfbpId: (state) => {
        return state.id
    }
}

const mutations = {
    set: (state, payload) => {
        state.data = payload;
    },

    addFbpBand: (state, payload) => {
        state.data.push(payload);
        state.fbpId = payload.id;
    },

    updateFbpBandById: (state, payload) => {
        for (let i = 0; i < state.data.length; i++) {
            if (state.data[i].id === payload.id) {
                state.data.splice(i, 1, payload);
            }
        }
    },

    removeFbpBandById: (state, payload) => {
        for (let i = 0; i < state.data.length; i++) {
            if (state.data[i].id == payload) {
                state.data.splice(i, 1);
            }
        }
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },

    setEditMode: (state, payload) => {
        state.editMode = payload.editMode;
        state.record = payload.record;
    }
}

const actions = {
    async fetchAll({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance.get(`/`, { params: payload });
            commit("setFetching", false);
            if (res.status == 200) {
                commit("set", res.data.payload.data);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async create({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.post(`/`, {
                data: payload
            });
            commit("setSaving", false);
            if (res.status == 200) {
                commit("addFbpBand", res.data.payload.data);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async update({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.put(`/${payload.id}`, {
                data: payload
            });
            commit("setSaving", false);
            if (res.status == 200) {
                commit("updateFbpBandById", res.data.payload);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async delete({ commit }, payload) {
        try {
            commit("setDeleting", true);
            let res = await axios_instance.delete(`/${payload.id}`);
            commit("setDeleting", false);
            if (res.status == 200) {
                commit("removeFbpBandById", payload.id);
            }
            return res
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async changeEditMode({ commit }, payload) {
        try {
            commit("setEditMode", payload);
        } catch (error) {
            throw errorHandler(error.response);
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}